import { useState } from "react"
import { Accordion } from "react-bootstrap";
import { IDynamicTableShape } from "../../../../../interface/DynamicTableShape.interface";

const FeedbackAndObservationComponent = ({feedback, setter, specificindex}:{feedback:IDynamicTableShape, setter:Function, specificindex:number}) => {
    const [answer, setAnswer] = useState<string>("");
  return (
    <Accordion className="border m-1">
        <Accordion.Header>
            {feedback.name}
        </Accordion.Header>
        <Accordion.Body>
           {feedback.description}
           {feedback.notes}
            <textarea className="form-control" rows={3} value={answer} onChange={({target})=>{
              setAnswer(target.value)
              setter(specificindex, answer)
              }}></textarea>
        </Accordion.Body>
    </Accordion>
  )
}

export default FeedbackAndObservationComponent